import { LOCALES } from 'localization/constants/configEnums';
import { getLocale } from 'shared/utils/getLocale';

export const DATE_FORMATS = {
  [LOCALES.enUS]: {
    YYYYMMDD: 'YYYYMMDD',
    'MMM DD': 'MMM DD',
    'MMMM DD': 'MMMM DD',
    'MMMM YYYY': 'MMMM YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'MMM DD YYYY': 'MMM DD YYYY',
    'MM/DD': 'MM/DD',
    'h:mm A': 'h:mm A',
  },
  [LOCALES.frFR]: {
    YYYYMMDD: 'D MMM YYYY',
    'MMM DD': 'D MMM',
    'MMMM DD': 'D MMMM',
    'MMMM YYYY': 'MMMM YYYY',
    'MM-DD-YYYY': 'D MM YYYY',
    'MMM DD YYYY': 'D MMM YYYY',
    'MM/DD': 'DD/MM',
    'h:mm A': 'HH[h]mm',
  },
};

export const localizeDate = (format: string) => {
  const locale = getLocale();
  return DATE_FORMATS?.[locale]?.[format] || format;
};
